window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

class CustomDialog {
    timer = null;
    active = false;
    listeners = {
        open: [],
        opened: [],
        close: [],
        closed: []
    };

    constructor(arg) {
        if (typeof arg === "string") {
            this.modal = document.querySelector(arg);
        } else {
            this.modal = arg;
        }

        if (this.modal) {
            this.headerClose = this.modal.querySelector('.dialog__close');
            this.headerTitle = this.modal.querySelector('.dialog__title');
            this.modalBody = this.modal.querySelector('.dialog__body');
            this.setup();
        }
    }

    get isOpen() {
        return this.modal.dataset.visible === "true";
    }

    on(type, callback) {
        this.listeners[type].push(callback);
    }

    open(title) {
        if (this.timer === null) {
            this.modal.dataset.visible = true;
            this.headerTitle.textContent = title || ''
            this.listeners.open.forEach(callback => callback());
            this.timer = setTimeout(() => {
                this.timer = null;
                this.active = true;
                this.listeners.opened.forEach(callback => callback());
            }, 500);
        }
    }

    close() {
        if (this.timer === null) {
            this.listeners.close.forEach(callback => callback());
            this.active = false;
            this.modal.dataset.visible = false;
            this.modalBody.innerHTML = '';
            this.timer = setTimeout(() => {
                this.timer = null;
                this.listeners.closed.forEach(callback => callback());
            }, 500);
        }
    }

    setup() {
        // 头部关闭按钮
        if (this.headerClose) {
            this.headerClose.addEventListener('click', () => this.close());
        }
    }
}